"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var overlay_1 = __importDefault(require("./overlay"));
var SearchBar = /** @class */ (function () {
    function SearchBar() {
        this.config = {
            htmlElements: {
                searchBarOpen: null,
                searchBarClose: null,
                searchBar: null
            },
            selectors: {
                searchBar: '[data-search-bar]',
                searchBarOpen: '[data-search-bar-open]',
                searchBarClose: '[data-search-bar-close]'
            }
        };
    }
    SearchBar.prototype.init = function () {
        this.config.htmlElements.searchBarOpen = document.querySelector(this.config.selectors.searchBarOpen);
        this.config.htmlElements.searchBarClose = document.querySelector(this.config.selectors.searchBarClose);
        this.config.htmlElements.searchBar = document.querySelector(this.config.selectors.searchBar);
        this.addEventListeners();
    };
    SearchBar.prototype.addEventListeners = function () {
        this.config.htmlElements.searchBarOpen.addEventListener('click', this.handleClickOpen.bind(this));
        this.config.htmlElements.searchBarClose.addEventListener('click', this.handleClickClose.bind(this));
    };
    SearchBar.prototype.handleClickOpen = function (event) {
        event.preventDefault();
        var input = this.config.htmlElements.searchBar.querySelector('input');
        overlay_1.default.on();
        this.config.htmlElements.searchBar.classList.remove('hide');
        input.focus();
    };
    SearchBar.prototype.handleClickClose = function (event) {
        event.preventDefault();
        overlay_1.default.off();
        this.config.htmlElements.searchBar.classList.add('hide');
    };
    return SearchBar;
}());
exports.default = new SearchBar();
